(() => {
  'use strict';

  const STORAGE_KEY = 'nj_collection_scroll_state_v3';
  const MAX_AUTO_LOADS = 40; // safety
  const PRODUCT_SEL = 'product-card[handle], product-card, .product-item, .product-card';
  const LOAD_MORE_BTN_SEL = '[data-load-more-button]';

  // The browser must not restore the scroll position by itself: on a page that is still short it clamps to the bottom.
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}

  let restoring = false;       // true while the saved position is being restored
  let userInterrupted = false; // the customer touched, scrolled or pressed a key while restoring: stop, do not jump

  function isLikelyCollectionPage() {
    const path = location.pathname || '';
    if (!path.includes('/collections/')) return false;
    if (/\/collections\/?$/.test(path)) return false;
    return !!document.querySelector(PRODUCT_SEL) || !!document.querySelector('load-more-pagination') || !!document.querySelector('[data-section-type="collection"]');
  }

  // "Load more": the new products appear in place, where the button was, and the page does not move.
  // Without this the browser keeps the button in view ("scroll anchoring"), so the page follows the button down and the
  // customer has to scroll back up to see what was loaded.
  function disableScrollAnchoring() {
    if (!isLikelyCollectionPage()) return;
    const style = document.createElement('style');
    style.textContent = 'main { overflow-anchor: none; }';
    document.head.appendChild(style);
  }

  function getProductCount() {
    return document.querySelectorAll(PRODUCT_SEL).length;
  }

  function isProductLink(a) {
    const href = (a.getAttribute('href') || '').trim();
    return href.includes('/products/');
  }

  function saveState() {
    if (!isLikelyCollectionPage()) return;
    const state = { url: location.href, scrollY: window.scrollY, productCount: getProductCount(), ts: Date.now() };
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }

  // Only restore when the customer comes back to the collection (back/forward), not on a fresh visit
  function isBackForward(persisted) {
    if (persisted) return true;
    try {
      const nav = performance.getEntriesByType('navigation')[0];
      return !!nav && nav.type === 'back_forward';
    } catch (e) { return false; }
  }

  ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((type) => {
    window.addEventListener(type, () => { userInterrupted = true; }, { passive: true });
  });

  function waitForCountIncrease(prevCount, timeoutMs) {
    const start = Date.now();
    return new Promise((resolve) => {
      const tick = () => {
        if (getProductCount() > prevCount) return resolve(true);
        if (Date.now() - start > timeoutMs) return resolve(false);
        setTimeout(tick, 60);
      };
      tick();
    });
  }

  async function ensureProductsLoaded(targetCount) {
    let loads = 0;
    while (!userInterrupted && getProductCount() < targetCount && loads < MAX_AUTO_LOADS) {
      const btn = document.querySelector(LOAD_MORE_BTN_SEL);
      // never auto-navigate to the next collection
      if (!btn || btn.hasAttribute('data-next-collection-button')) break;
      if (!btn.getAttribute('data-next-url')) break;
      const prev = getProductCount();
      if (btn.disabled || btn.getAttribute('aria-busy') === 'true') {
        if (!(await waitForCountIncrease(prev, 9000))) break;
        continue;
      }
      btn.click();
      loads += 1;
      if (!(await waitForCountIncrease(prev, 12000))) break;
    }
  }

  async function restoreState(persisted) {
    if (!isLikelyCollectionPage() || !isBackForward(persisted)) return;
    let raw = null;
    try { raw = sessionStorage.getItem(STORAGE_KEY); } catch (e) {}
    if (!raw) return;
    let state = null;
    try { state = JSON.parse(raw); } catch (e) { return; }
    if (!state || state.url !== location.href) return;
    if (state.ts && (Date.now() - state.ts) > 1000 * 60 * 30) return;

    const targetCount = Number(state.productCount || 0);
    const targetScroll = Number(state.scrollY || 0);
    userInterrupted = false;
    restoring = true;
    try {
      if (targetCount > 0) await ensureProductsLoaded(targetCount);
      if (!userInterrupted) {
        await new Promise((resolve) => requestAnimationFrame(() => resolve()));
        window.scrollTo(0, targetScroll);
      }
    } finally {
      restoring = false;
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
    }
  }

  // Save only when navigating to a product page from a collection
  document.addEventListener('click', (e) => {
    if (!isLikelyCollectionPage()) return;
    const a = e.target.closest('a[href]');
    if (!a || !isProductLink(a)) return;
    saveState();
  }, { capture: true });

  document.addEventListener('DOMContentLoaded', () => { disableScrollAnchoring(); restoreState(false); });
  window.addEventListener('pageshow', (e) => { if (e.persisted) restoreState(true); });
})();
